// extracted by mini-css-extract-plugin
export default {"root":"CardDialogContent_root__LXfuq"};